<!DOCTYPE html>
<ng-scrollbar>
    <form id="data-filter-form" [formGroup]="dataFilterForm">
        <div class="ot-data-view-filter">
            <div class="ot-table-filter-title" i18n>Refine by</div>
            <div class="ot-data-view-filters-container">
                <div class="ot-data-view-filters">
                    @for(filter of filters; track filter){
                    <div [value]="filter" data-name="data-filter-control" class="ot-form-control">
                        <label class="ot-form-control__label" [attr.for]="filter.id">{{filter.name}}</label>
                        @switch(filter.type){
                        @case(FilterType.STRING){
                        <input [attr.id]="filter.id" [formControlName]="filter.name" class="ot-input" (keyup)="setCtrlValue($event, filter)">
                        }
                        @case(FilterType.DROPDOWN){
                        <div class="ot-select"> 
                            <select [attr.id]="filter.id" [formControlName]="filter.name" (change)="setCtrlValue($event, filter)" >
                                @for(option of filter.values; track option){
                                <option [value]="option" [value]="option.value" (change)="subscribe($event, filter)">{{option.text}}</option>
                                }
                            </select>
                        </div>
                        }
                        }
                    </div>
                    }
                </div>
            </div>
            <div>
                <div class="ot-data-view-filters-button-group">
                    <button id="data-filter-apply" role="button" otsc-button color="primary" class="ot-btn--is-micro ot-btn--is-primary is-pulled-left" (click)="onApply()" [disabled]="!dataFilterForm.dirty" i18n>Apply</button>
                    <button id="data-filter-clear" role="button" otsc-button color="secondary" class="ot-btn--is-micro is-pulled-right" (click)="onCancel()" [disabled]="!dataFilterForm.dirty" i18n>Clear</button>
                </div>
            </div>
        </div>
    </form>
</ng-scrollbar>